import { FaBolt } from "react-icons/fa";

export default function Loader() {
	return (
		<div className="flex justify-center items-center h-screen bg-gray-100">
			<div className="relative flex flex-col items-center">
				{/* Multi-Color Spinning Ring */}
				<div className="relative flex justify-center items-center">
					<div className="animate-spin rounded-full h-16 w-16 md:h-20 md:w-20 border-4 border-transparent border-t-[#E6007E] border-r-[#24395E] border-b-[#4EBCC3] border-l-[#F3930A]" />

					{/* Spinning Bolt Icon */}
					{/* <div className="absolute inset-0 flex justify-center items-center">
						<FaBolt className="text-[#E6007E] text-3xl md:text-4xl animate-pulse" />
					</div> */}
				</div>

				{/* Loading Text */}
				<p className="mt-3 text-[#E6007E] font-semibold text-xs md:text-sm">
					Chargement...
				</p>
			</div>
		</div>
	);
}
